import(/* webpackMode: "eager" */ "/vercel/path0/app/info/faq/page.tsx");
